<template>
    <b-alert show :variant="autoReload ? 'secondary' : 'danger'" class="mt-4">
        <div v-if="autoReload" class="text-center">
            <fa-icon icon="circle-notch" size="4x" spin></fa-icon>
        </div>
        <template v-else>
            <p>{{ 'messages.socket_reload' | lang }}</p>
            <hr>
            <p class="mb-0">
                <button class="btn btn-danger" @click="reload">{{ 'refresh_window' | lang }}</button>
            </p>
        </template>
    </b-alert>
</template>

<script>
export default {
    props: ['autoReload'],

    methods: {
        reload() {
            parent.postMessage({ reload: true }, '*');
        },
    },

    mounted() {
        if (this.autoReload) {
            this.reload();
        }
    },
}
</script>